/**
 * Web Style Import
 *
 */

import './style/dnb-skeleton.scss'
